import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import * as wjCore from "wijmo/wijmo";
import { VirtualOrderDto } from "@dashboard/modules/shipping-management/virtual-order-receipt/model/virtual-order.dto";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { VirtualOrderReceiptFormComponent } from "@dashboard/modules/shipping-management/virtual-order-receipt/components/virtual-order-receipt-form/virtual-order-receipt-form.component";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { findIndex } from "lodash";

@Component({
  selector: "kl-virtual-order-receipt-list",
  templateUrl: "./virtual-order-receipt-list.component.html",
  styleUrls: ["./virtual-order-receipt-list.component.scss"],
})
export class VirtualOrderReceiptListComponent implements OnInit, AfterViewInit {
  @Input() mode;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() templateContext: any;
  @Input() dblSelect = false;
  deleteOptions: Object;
  editOptions: Object;
  filterSelectItems = [
    {
      name: "document_num",
      description: "document_num",
    },
    {
      name: "external_document_num",
      description: "external_document_num",
    },
    {
      name: "current_account",
      description: "dealers_description",
      objectKey: "description",
      prefix: "current_account_description",
      parameterName: "current_account_description",
    },
    {
      name: "customer",
      description: "customer_description",
      objectKey: "description",
      prefix: "customer_description",
      parameterName: "customer_description",
    },
  ];
  designList = [];
  viewerData = {
    report_fields: [],
    customer: {},
    current_account: {},
  };
  designCollectionView: wjCore.CollectionView;
  currentLine: VirtualOrderDto = new VirtualOrderDto();
  @ViewChild("designListModal", { static: true }) public designListModal: any;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  gridComponent: any;
  parentModule = "SHIPPING_MANAGEMENT";
  module = "VIRTUAL_ORDER_DESIGN_LIST";
  key = "grdVirtualOrderDesignList";
  type = "REPORT_DESIGN";
  sourceData = {
    report_fields: [
      {
        material_code: "",
        material_description: "",
        current_account_id: null,
        customer_id: null,
        license_key: "",
        user_count: null,
      },
    ],
    current_account: {
      id: null,
      code: "",
      description: "",
    },
    customer: {
      id: null,
      code: "",
      description: "",
      tax_office: "",
      tax_num: "",
      phone: "",
      phone2: "",
      city_description: "",
    },
  };

  dropdownActions = [
    {
      slug: "copy",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".009")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("loading");
          this.apiService.getDataById("virtual-order", cell.item.id).subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                const copyData = UtilService.deepCopy(response);
                delete copyData.id;
                delete copyData.code;
                const tabConfig = <TabConfig>{
                  id: "virtualOrderCopy" + response.id,
                  title: "virtual_order_receipt",
                  childTemplate: <DynamicComponent>{
                    mode: "copy",
                    tabId: "virtualOrderCopy" + response.id,
                    template: VirtualOrderReceiptFormComponent,
                    dataContext: copyData,
                    service: "virtual-order",
                    isReadOnly: false,
                  },
                  isCloseable: true,
                };
                this.explorerService.openTab(tabConfig);
              }
            },
            (error) => this.handleError(error)
          );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
    {
      slug: "approve",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".006")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("approving");
          this.apiService.getDataById("virtual-order", cell.item.id).subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                if (response.document_state === "DRAFT") {
                  this.apiService
                    .addData("virtual-order/approve", {
                      id: cell.item.id,
                    })
                    .subscribe(
                      () => {
                        this.gridComponent.filter(this.gridComponent._filter);
                      },
                      (error) => this.handleError(error)
                    );
                } else {
                  this.handleError("approved_fiches_cannot_be_approve");
                }
              }
            },
            (error) => this.handleError(error)
          );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
    {
      slug: "generate_licence_key",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".007")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("creating_licence_key");
          this.apiService.getDataById("virtual-order", cell.item.id).subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                if (response.document_state === "APPROVED") {
                  this.apiService
                    .addData("product-license", {
                      virtual_order: {
                        id: cell.item.id,
                      },
                    })
                    .subscribe(
                      () => {
                        this.klLoadingService.hide();
                        this.toasterService.toastSuccess(
                          "licence_keys_create_success"
                        );
                      },
                      (error) => this.handleError(error)
                    );
                } else {
                  this.handleError(
                    "not_approved_fiches_cannot_be_create_licence_key"
                  );
                }
              }
            },
            (error) => this.handleError(error)
          );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
    {
      slug: "print",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".008")) {
          this.currentLine = cell.item;
          this.klLoadingService.show("loading");
          const filter = {
            parent: {
              module: this.parentModule,
            },
            module: this.module,
            key: this.key,
          };
          this.apiService.getFilteredData("design", filter).subscribe(
            (response) => {
              this.klLoadingService.hide();
              this.designList = response.data ? response.data : [];
              this.designCollectionView = new wjCore.CollectionView(
                this.designList
              );
              this.designCollectionView.refresh();
              this.designListModal.show();
            },
            (error) => this.handleError(error)
          );
          this.gridComponent.alertShow = false;
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
  ];

  constructor(
    private apiService: ApiService,
    private toasterService: ToastService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private alertService: KlSweetAlertService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    this.deleteOptions = {
      deleteWithConfirm: false,
      objectProperty: "document_state",
      objectValue: "APPROVED",
      alertMessage: "approved_fiches_cannot_be_deleted",
    };
    this.editOptions = {
      objectProperty: "document_state",
      objectValue: "APPROVED",
      alertMessage: "approved_fiches_cannot_be_changed",
    };
  }

  ngAfterViewInit(): void {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }

  printLabel() {
    this.viewerData["report_fields"] = [];
    this.viewerData["current_account"] = {};
    this.viewerData["customer"] = {};
    this.apiService
      .addData("virtual-order/print", {
        id: this.currentLine.id,
      })
      .subscribe(
        (response) => {
          if (response === undefined) {
            this.handleError("error_data");
          } else {
            this.viewerData["report_fields"] = response.report_fields;
            this.viewerData["current_account"] = response.current_account;
            this.viewerData["customer"] = response.customer;
            if (this.viewerData.report_fields.length > 0) {
              const newWindow: any = window.open("report-viewer", "_blank");
              newWindow.viewerData = this.viewerData;
              newWindow.currentReport = this.designCollectionView.currentItem;
            } else {
              this.designListModal.hide();
            }
          }
        },
        (error) => this.handleError(error)
      );
  }

  openDesigner(type: string, item?: any) {
    const newWindow: any = window.open("report-designer", "_blank");
    newWindow.mode = type;
    if (type === "add") {
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    if (type === "edit") {
      newWindow.currentReport = JSON.stringify(item);
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    newWindow.blur();
  }

  deleteDesign(item) {
    this.alertService.alertDelete(
      {
        title: "warning",
        text: "entry_must_be_delete",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", item.id).subscribe(
          () => {
            const index = findIndex(
              this.designCollectionView.sourceCollection,
              { id: item.id }
            );
            if (index !== -1) {
              this.designCollectionView.remove(
                this.designCollectionView.sourceCollection[index]
              );
            }
          },
          (errDeletePreference) => this.handleError(errDeletePreference)
        );
      }
    );
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.gridComponent.alertMessage = this.utilService.alertErrorMessage(error);
    this.gridComponent.alertType = "error";
    this.gridComponent.alertShow = true;
    this.gridComponent.cd.markForCheck();
  }
}
